import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import css from "../css/Addcase.module.css";
import Compressor from "compressorjs";
import css1 from "../css/Pan.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/Loader.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/viewGame1.css";
import "../css/layout.css";
import Swal from "sweetalert2";
import Header from "../Components/Header";
import socket from "../Components/socket";
import "../css/landing.css";
import Modal from "react-bootstrap/Modal";
import { BsArrowRight, BsQrCodeScan } from "react-icons/bs";
import DownloadLink from "react-download-link";
import Spinner from "react-bootstrap/Spinner";
import SabpaisaPaymentGateway from "./SabpaisaPaymentGateway";
import QRCode from "qrcode.react";
import { apiRequest } from "../store/allApi";

const Addcase = ({ walletUpdate }) => {
  // BASE URL
  const [allBank, setAllBank] = useState([])
  const [acdata, setacdata] = useState('')
  const beckendLocalApiUrl = process.env.REACT_APP_API_BASE_URL;
  const beckendLiveApiUrl = process.env.REACT_APP_API_BASE_URL;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const [userAllData, setUserAllData] = useState();


  const userData = localStorage.getItem('udata')
  const udata = JSON.parse(userData)

  const phone = localStorage.getItem('phone')



  const [clientCode, setClientCode] = useState("RALY03");
  const [transUserName, setTransUserName] = useState("nightking41232323_15556");
  const [transUserPassword, setTransUserPassword] = useState("RALY03_SP15556");
  const [authkey, setAuthkey] = useState("b5gF6mGKDHicH6WB");
  const [authiv, setAuthiv] = useState("wD6KKUsCumUEeogG");


  // sabpay
  // alert(udata.Name.replace(/[^a-zA-Z0-9]/g,''))
  const [payerName, setPayerName] = useState(udata.Name.replace(/[^a-zA-Z0-9]/g, ''));
  const [payerEmail, setPayerEmail] = useState(udata.Email);
  const [payerMobile, setPayerMobile] = useState(phone);


  const [clientTxnId, setclientTxnId] = useState(null);

  const [payerAddress, setPayerAddress] = useState("Kolkata");
  const [callbackUrl, setCallbackUrl] = useState("/sabpaisaGateway");

  const [isOpen, setIsOpen] = useState(false);


  const history = useHistory();

  const access_token = localStorage.getItem("token");

  const [isLoading1, setIsloading1] = useState(false);
  const [global, setGlobal] = useState(10.00);
  const [next, setNext] = useState(1);
  const [process1, setProcess] = useState(false);
  const [isMypayInActive, setIsMyPayActive] = useState(false);
  const [isUpiGateway, setUpiGateway] = useState(false);
  const [isUpiGateway1, setUpiGateway1] = useState(false);
  const [manualDeposit, setManualDeposit] = useState(false);


  const [manualData, setManualData] = useState([]);
  const [PayOneImage, setPayOneImage] = useState("");
  const [PayTwoImage, setPayTwoImage] = useState("");
  const [PayThreeImage, setPayThreeImage] = useState("");
  const [PayFourImage, setPayFourImage] = useState("");
  const [PayFiveImage, setPayFiveImage] = useState("");

  // hooks for payment url
  const [PayNow1Url, setPaynow1Url] = useState("");
  const [PayNow2Url, setPaynow2Url] = useState("");
  const [PayNow3Url, setPaynow3Url] = useState("");
  const [PayNow4Url, setPaynow4Url] = useState("");
  const [PayNow5Url, setPaynow5Url] = useState("");

  const [show_won, setShow_won] = useState(false);
  const [show_won1, setShow_won1] = useState(false);
  const handleClose_won = () => setShow_won(false);
  const [scrnshot, setScrnshot] = useState(null);
  const [fecthStatus, setFecthStatus] = useState();
  const handleShow_won = () => setShow_won(true);
  const handleShow_won1 = () => setShow_won1(true);
  const handleClose_won1 = () => setShow_won1(false);
  const [scrnshot1, setScrnshot1] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [minLimit, setMinLimit] = useState(null);
  const [maxLimit, setMaxLimit] = useState(null);
  const [utr, setutr] = useState("");
  

  // console.log(maxLimit)

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const [isMobile, setMobile] = useState(false);

  // Hoada Hooks

  const [hoadaPay, setHoadaPay] = useState(false);


  const detail = localStorage.getItem('')

  useEffect(() => {
    setMinLimit(addCaseSetting.depositlimitMin);
    setMaxLimit(addCaseSetting.depositlimitMax);
  }, []);



  // acount upi deposit

  const bankList = async () => {

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };


    // axios
    //   .get(baseUrl + "get/allbank", { headers })
    //   .then(res => {
    //     // setLoading(false)
    //     setAllBank(res.data?.data)
    //     console.log(allBank[0]?.minLimit)
    //   })
    //   .catch(e => {
    //     // setLoading(false)
    //     console.log(e)
    //   })
    try {
      const res = await apiRequest(`get/allbank`, "GET", null, headers)
    //  setLoading(false)
        setAllBank(res.data?.data)
    } catch (e) {
      // setLoading(false)
      console.log(e)
    }
  }

  const myBank = (data) => {
    console.log(next)
    setacdata(data)
    setNext(4);
  }

  useEffect(() => {
    console.log(next)
    bankList()
  }, [])


  // copy details

  const copyCode1 = (e) => {
    navigator.clipboard.writeText(e);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Copy SuccessFully",
      showConfirmButton: false,
      timer: 1200,
    });
  };


  const handleNext = () => {
    // if (payerEmail == null) {
    //   Swal.fire({
    //     title: `Invalid Email Please Update your email from profile page`,

    //     confirmButtonText: "OK",
    //     content: "custom-swal-content",
    //   });
    // }
    // else
    if (global < minLimit || global > maxLimit) {
      Swal.fire({
        title: `Minimum amount should be greater than ${minLimit} and maximum amount should be less than ${maxLimit}`,

        confirmButtonText: "OK",
        content: "custom-swal-content",
      });
    } else {
      setNext(2);
    }
  };


  // upigateway
  const upigateway = () => {

    setProcess(true)
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`,
    }
    axios
      .post(
        baseUrl + `user/depositeupi?amount=${global.toFixed(2)}`,
        {
          amount: global,
        },
        { headers },
      )
      .then((res) => {
        if (res.data.data.status) {
          // console.log(res.data.data.data.payment_url)
          // console.log(res.data.data.data.order_id)
          let order_id = res.data.txnID
          let order_token = res.data.data.data.order_id
          //setProcess(false);
          window.open(res.data.data.data.payment_url)
          setTimeout(() => {
            checkupideposit(order_id, order_token)
            setProcess(false)
          }, 60000)
        } else {
          setProcess(false)
          Swal.fire({
            title: res.data.data.msg,
            icon: 'danger',
            confirmButtonText: 'OK',
          })
        }
      })
      .catch((e) => {
        alert(e)
      })

  }


const upigateway1 = async () => {
  try {
    setProcess(true);
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const response = await apiRequest(
      `pg-upigateway?amount=${global.toFixed(2)}`, // ✅ wrap in backticks
      "POST",
      { amount: global },
      headers
    );

    if (response.data.data?.status) {
      window.open(response.data?.data?.result?.payment_url);
      setTimeout(() => {
        setProcess(false);
      }, 60000);
    } else {
      setProcess(false);
      Swal.fire({
        title: response.data.data.msg,
        icon: "error", // ✅ Swal doesn’t support 'danger'
        confirmButtonText: "OK",
      });
    }
  } catch (e) {
    setProcess(false);
    Swal.fire({
      title: "Something went wrong",
      text: e.message,
      icon: "error",
    });
  }
};


  const [upiLink, setUpiLink] = useState("");

  const checkupideposit = (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `depositupipay/response`,
        { order_id, order_token },
        { headers }
      )
      .then((res) => {
        const icon = res.data.status == "PAID" ? "success" : "danger";
        const title =
          res.data.status == "PAID"
            ? "Deposit submited successfully"
            : "Transaction Failed";
        history.push("/");
        setTimeout(() => {
          Swal.fire({
            title: title,
            icon: icon,
            confirmButtonText: "OK",
          });
        }, 1000);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
        }
      });
  };


  const meeApi = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`me`, "GET", null, headers)
      if (res.data) {
        setUserAllData(res.data);
        setPayerMobile(res.data.Phone)
      }
    } catch (e) {
      if (e.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }

    }
    finally {
    }

  }


  const webSetting = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`website/setting`, "GET", null, headers)
      if (res.data) {
        setupi(res.data.upiId);
        setUpiGateway(res.data.isUpiGateway);
        setManualDeposit(res.data.manualDeposit);
      }
    } catch (e) {
      setUpiGateway(false);

    }
    finally {
    }

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      setMobile(true);
    }
  }

  useEffect(() => {
    meeApi()
    webSetting()
  }, []);

  useEffect(() => {

  }, []);


  // clear Image
  const clearImage = (e) => {
    setScrnshot1(null);
    setScrnshot(null);
  };
  // MANUAL PAYMENTS METHODS API

  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          if (compressedResult) {
            setScrnshot(compressedResult);
          } else {
            setScrnshot(image);
          }
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };

  const ManualPayment = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const result = await apiRequest(`gatewaysettings/data`, "GET", null, headers)
      
      if (result) {
        setManualData(result);
        setUpiGateway1(result?.data?.isUpiGateway1);
        setPayOneImage(result?.isPayOneImage);
        setPayTwoImage(result?.isPayTwoImage);
        setPayThreeImage(result?.isPayThreeImage);
        setPayFourImage(result?.isPayFourImage);
        setPayFiveImage(result?.isPayFiveImage);
      }
    } catch (e) {
      console.log("error", e);
    }
    finally {
    }
  };

  useEffect(() => {
    ManualPayment();
  }, []);


  // getImage URl
  const [ImageUrl, setImageUrl] = useState("");
  const [PaymentLink, setPaymentLink] = useState("");
  const [upi, setupi] = useState("");
  const isKYCCompleted = udata?.verified; // Check if KYC is completed
  const handleSetAmount = (amount) => {
    if (amount > addCaseSetting?.depositKyc && !isKYCCompleted) {
      alert("KYC completion is required for deposits above 500.");
      return;
    }
    setGlobal(amount);
  };

  const getImageUrl = (image, url) => {
    setImageUrl(image);
    setPaymentLink(url);
  };

  // code link payment

  const copyCode = (e) => {
    navigator.clipboard.writeText(upi);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const ManualPayments = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    setIsloading1(true);
    var formdata = new FormData();
    formdata.append("Transaction_Screenshot", scrnshot);
    formdata.append("amount", global);
    formdata.append("referenceId", utr);


    try {

      const result = await apiRequest(`manual/deposit/txn`, "POST", formdata, headers);
      // const result = await res?.json(); // Await the JSON parsing
      
      if (result) {
        setIsloading1(false);
        if (result.data.data?.status === "Pending") {
          Swal.fire({
            title: result.data.message,
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: result.data.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }

        history.push("/");
        handleClose_won();
      }
    }
    catch (e) {
      console.log("error", e)

    }
    finally {
    }

  };


  return (
    <>
      <Header user={userAllData} />
      <div className="leftContainer mb_space">
        <div className="pt-5 mt-5  Orher_page_main_section">
          <div className='gameCard pt-2'>
            <div className='alrt_msg_div'>
              <h5 className=''>
                {JSON.parse(localStorage.getItem('sitSetting')) == 'undefined'
                  ? ''
                  : JSON.parse(localStorage.getItem('sitSetting'))
                    ?.deposit_message}
              </h5>
            </div>
          </div>
          <>
            <section className="win_modal">
              <Modal
                show={show_won1}
                onHide={handleClose_won1}
                className="cancel_popup_reason_popup"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  {upiLink && (
                    <div>
                      {/* <QRCode value={upiLink} size={256} /> */}
                      <iframe
                        src={upiLink}
                        title="QR Code"
                        style={{ width: "100%", height: "400px", border: "none" }}
                      ></iframe>
                    </div>
                  )}


                  <button type="button" className="close-button " onClick={handleClose_won1}>Close</button>

                </Modal.Body>
              </Modal>
            </section>

          </>
          {Boolean(!process1) && (
            <div>
              {Boolean(next == 1) && (
                <div className="">
                  <h2 className="profile_headings" style={{ color: "black" }}>Choose amount to add</h2>
                  <div className="add_amount_main_box mt-4">
                    <div className="add_amount_main_box_inner">
                      <label className="label">Enter Amount</label>
                      <div className="enter_amount_input_box">
                        <span>₹</span>
                        <input
                          className="enter_amount_input"
                          type="tel"
                          id="amountInput"
                          value={global}
                          onChange={(e) => {
                            e.target.value > 0
                              ? e.target.value <= 50000
                                ? setGlobal(parseInt(e.target.value))
                                : setGlobal(50000)
                              : e.target.value < 0
                                ? setGlobal(10)
                                : setGlobal(0);
                          }}
                        />
                      </div>
                      <div className="add_amount_min_max">
                        <p>
                          {" "}
                          <small>Min: {addCaseSetting?.depositlimitMin}</small> 
                          <small> Max: {addCaseSetting?.depositlimitMax}</small>
                        </p>
                      </div>
                    </div>

                    <div className="add_amount_buttons_main">
                                          {[100, 250, 500, 2000].map((amount) => (
                                            <button
                                              key={amount}
                                              onClick={() => handleSetAmount(amount)}
                                            >
                                              <span>
                                                ₹ 
                                              </span>
                                              <span>{amount}</span>
                                            </button>
                                          ))}
                                        </div>



                    <div className="add_cash_nest_btn">
                      {addCaseSetting.isDeposit ? (
                        <button
                          type="button"
                          id="addcase"
                          className=""
                          onClick={handleNext}
                        >
                          Next <BsArrowRight className="icons" />
                        </button>
                      ) : (
                        <p className="deposit_service" id="depositClose">
                          Deposit services Close for some time
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {Boolean(next == 2) && (
                <div className="">
                  <>
                    <div className="pb-3">
                      <div className={`${css.games_section}`}>
                        <div className="d-flex position-relative align-items-center justify-content-between">
                          <div className="add_cash_small_haedings">
                            Amount to be added ₹<b>{global}</b>
                          </div>

                          <button
                            type="button"
                            onClick={() => setNext(1)}
                            className="samll_btn"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="mt-1">
                      <div className="profile_headings" style={{ color: "black" }}>
                        Pay Through QR CODE
                      </div>

                      {/* upigateway */}
                      {/* {Boolean(isUpiGateway) && (
                        <div
                          onClick={() => upigateway()}
                          className="add-fund-box mt-3"
                          style={{ paddingTop: "0px", height: "60px" }}
                        >
                          {isLoading ? (
                            <div
                              className="loaderReturn"
                              style={{ zIndex: "99" }}
                            >
                              <img
                                src={"/images/LandingPage_img/loader1.gif"}
                                style={{ width: "100%" }}
                              />
                            </div>
                          ) : (
                            <div
                              className="d-flex align-items-center"
                              style={{
                                backgroundColor: "#fafafa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "7px",
                              }}
                            >
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  height: "60px",
                                  display: "flex",
                                  textAlign: "center",
                                }}
                              >
                                <img
                                  width="40px"
                                  src="/UPI.png"
                                  alt=""
                                  style={{
                                    marginLeft: "7px",
                                    paddingBottom: "10px",
                                    paddingLeft: "3px",
                                    paddingTop: "5px",
                                  }}
                                />
                              </div>
                              <div className="d-flex justify-content-center flex-column ml-4">
                                <div className="jss30">
                                  <strong>Pay Now</strong>
                                </div>
                                <div className="jss31"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      )} */}

                      {/* pg-gateway */}
                      {  global >= manualData?.data?.upiGatewayMin1 && Boolean(isUpiGateway1) && global <= manualData?.data?.upiGatewayMax1 ? (
                        <div
                          onClick={() => upigateway1()}
                          className="add-fund-box mt-3"
                          style={{ paddingTop: "0px", height: "60px" }}
                        >
                          {isLoading ? (
                            <div
                              className="loaderReturn"
                              style={{ zIndex: "99" }}
                            >
                              <img
                                src={"/images/LandingPage_img/loader1.gif"}
                                style={{ width: "100%" }}
                              />
                            </div>
                          ) : (
                            <div
                              className="d-flex align-items-center"
                              style={{
                                backgroundColor: "#fafafa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "7px",
                              }}
                            >
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  height: "60px",
                                  display: "flex",
                                  textAlign: "center",
                                }}
                              >
                                <img
                                  width="40px"
                                  src="/UPI.png"
                                  alt=""
                                  style={{
                                    marginLeft: "7px",
                                    paddingBottom: "10px",
                                    paddingLeft: "3px",
                                    paddingTop: "5px",
                                  }}
                                />
                              </div>
                              <div className="d-flex justify-content-center flex-column ml-4">
                                <div className="jss30">
                                  <strong style={{ color: "black" }}>Pay Qr Code</strong>
                                </div>
                                <div className="jss31"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : null}

                      {/* Account Deposite */}

                      <>
                        {allBank?.map((item, index) => {
                            const type = item?.type ? item.type.toUpperCase() : "";
                              
                            return (
                              <div key={index}>
                                {item?.status &&
                                  global >= item?.minLimit &&
                                  global <= item?.maxLimit ? (
                                  <div>
                                    <div
                                      onClick={() => myBank(item)}
                                      className="add-fund-box mt-3"
                                      style={{ paddingTop: "0px", height: "60px", cursor: "pointer" }}
                                    >
                                      <div
                                        className="d-flex align-items-center"
                                        style={{
                                          backgroundColor: "#fafafa",
                                          border: "1px solid #e0e0e0",
                                          borderRadius: "7px",
                                        }}
                                      >
                                        <div
                                          className="d-flex align-items-center"
                                          style={{ height: "60px" }}
                                        >

                                          {type === "WHATSAPP" ? (
                                            <a
                                              href={`https://wa.me/+91${item?.accountNumber || ""}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <img width="40px" src="/images/whatsapp.png" alt="WhatsApp" />
                                            </a>
                                          ) : type === "UPI" ? (
                                            <img width="40px" src="/upi.png" alt="UPI" />
                                          ) : type === "Bank" ? (
                                            <div class="alrt_deposit" >
                                    <div className="Refer_code" >
                                      <p style={{ fontSize: "20px" }}>
                                        Bank Name :  <span style={{ color: 'red' }} className="mb-4">
                                        </span></p>
                                    </div>

                                  </div>
                                          ) : (
                                            <img width="40px" src="/Bank.png" alt="Bank" />
                                          )}

                                        </div>

                                        <div className="ml-4">
                                          <strong style={{ color: "black" }}>
                                            PAY WITH {type || "METHOD"}
                                          </strong>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            );
                          })}
                      </>

                      <div className="Qrcode">
                        {/* Qr code 1 */}
                        {manualData?.isPayNowOne ? (
                          <div
                            onClick={() => {
                              setNext(3);
                              getImageUrl(PayOneImage, PayNow1Url);
                            }}
                            // onClick={() => fetchPaymentUrl()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>QR CODE 1</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {/* Qr code 2 */}
                        {manualData?.isPayNowTwo ? (
                          <div
                            onClick={() => {
                              setNext(3);
                              getImageUrl(PayTwoImage, PayNow2Url);
                            }}
                            // onClick={() => fetchPaymentUrl()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>QR CODE 2</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {/* Qr code 3 */}
                        {manualData?.isPayNowThree ? (
                          <div
                            onClick={() => {
                              setNext(3);
                              getImageUrl(PayThreeImage, PayNow3Url);
                            }}
                            // onClick={() => fetchPaymentUrl()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>QR CODE 3</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {/* Qr code 4 */}
                        {manualData?.isPayNowFour ? (
                          <div
                            onClick={() => {
                              setNext(3);
                              getImageUrl(PayFourImage, PayNow4Url);
                            }}
                            // onClick={() => fetchPaymentUrl()}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>QR CODE 4</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {/* Qr code 5 */}
                        {manualData?.isPayNowFive ? (
                          <div
                            onClick={() => {
                              setNext(3);
                              getImageUrl(PayFiveImage, PayNow5Url);
                            }}
                            className="add-fund-box mt-3"
                            style={{ paddingTop: "0px", height: "60px" }}
                          >
                            {isLoading ? (
                              <div
                                className="loaderReturn"
                                style={{ zIndex: "99" }}
                              >
                                <img
                                  src={"/images/LandingPage_img/loader1.gif"}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "7px",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    width="40px"
                                    src="/UPI.png"
                                    alt=""
                                    style={{
                                      marginLeft: "7px",
                                      paddingBottom: "10px",
                                      paddingLeft: "3px",
                                      paddingTop: "5px",
                                    }}
                                  />
                                </div>
                                <div className="d-flex justify-content-center flex-column ml-4">
                                  <div className="jss30">
                                    <strong>QR CODE 5</strong>
                                  </div>
                                  <div className="jss31"></div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </>
                </div>
              )}


              {/* Account deposite */}

              {Boolean(next == 4) && (
                <>

                  <div className="pb-3">
                    <div className={`${css.games_section}`}>
                      <div className="d-flex position-relative align-items-center justify-content-between">
                        <div className="add_cash_small_haedings">
                          Amount to be added ₹<b>{global}</b>
                        </div>

                        <button
                          type="button"
                          onClick={() => setNext(1)}
                          className="samll_btn"
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* <div class="alrt_msg_div" >
                    <h5 class="">
                      अगर कोई यूजर मैन्युअल डिपॉजिट अमाउंट जितना पे करता है उतना ही पेमेंट डालकर UTR नंबर और स्क्रीनशॉट सबमिट करें अगर आप पेमेंट कम या और ज्यादा डालते हो आपका किया हुआ डिपॉजिट ऐड नहीं होगा |
                    </h5>
                  </div> */}
                  
                  {
                    acdata?.type == 'whatsapp' ?
                    <>
                   

                

                    <div className="add-fund-box mt-4" style={{ paddingTop: "0px", minHeight: "80px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <a
                        href="https:walletUpdate.me/+91${acdata?.accountNumber}"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", width: "100%" }}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{
                            backgroundColor: "#fafafa",
                            border: "1px solid #e0e0e0",
                            borderRadius: "7px",
                            padding: "15px",
                            textDecoration: "none",
                          }}
                        >
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              height: "60px",
                              width: "60px",
                              display: "flex",
                              textAlign: "center",
                            }}
                          >
                            <img
                              src="images/whatsapp.png"
                              alt="Telegram"
                              style={{ width: "50px", height: "50px" }}
                            />
                          </div>
                          <div className="d-flex justify-content-center flex-column ml-4">
                            <div className="jss30">
                              <strong style={{ color: "black", fontSize: "1.1rem" }}>
                                Contact on Whatsapp
                              </strong>
                            </div>
                            <div className="jss31" style={{ color: "#666", fontSize: "0.9rem" }}>
                            Whatsapp खोलने के लिए क्लिक करें और डिपॉज़िट में मदद के लिए हमारी सपोर्ट टीम से संपर्क करें।
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  <br></br>
                
                  </>
                      : ""
                  }
                  {
                    acdata?.upiId && !acdata?.qrcodeImage ?
                      <div class="alrt_deposit" >
                        <div className="Refer_code">
                          <p style={{ fontSize: "20px" }}>
                            UPI ID :  <span style={{ color: 'red' }} className="mb-4">
                              {acdata?.upiId}
                            </span></p>
                          <button onClick={() => copyCode1(acdata?.upiId)}>Copy</button>
                        </div>

                      </div>
                      : ""}
                  {
                    acdata?.qrcodeImage && !acdata?.accountNumber ?
                      <div class="alrt_deposit" >
                        {
                          acdata?.upiId ?
                            <div className="Refer_code">
                              <p style={{ fontSize: "20px" }}>
                                UPI ID :  <span style={{ color: 'red' }} className="mb-4">
                                  {acdata?.upiId}
                                </span></p>
                              <button onClick={() => copyCode1(acdata?.upiId)}>Copy</button>
                            </div>
                            : ""}
                        <div class="alrt_deposit" >
                          <div className="Refer_code style-1">
                            <img style={{ width: "100%" }} src={baseUrl + `/${acdata?.qrcodeImage}`} ></img>

                          </div>
                        </div>
                      </div>
                      : ""}

                      {
                    
                    acdata?.accountNumber && acdata?.bankName && acdata?.accountHolderName && acdata?.ifscCode ?
                    
                      <>
                        <div class="alrt_deposit" >
                          <div className="Refer_code" >
                            <p style={{ fontSize: "20px" }}>
                              Bank Name :  <span style={{ color: 'red' }} className="mb-4">
                                {acdata?.bankName}
                              </span></p>
                          </div>

                        </div>
                        <div class="alrt_deposit" >
                          <div className="Refer_code">
                            <p style={{ fontSize: "20px" }}>
                              Account Number :  <span style={{ color: 'red' }} className="mb-4">
                                {acdata?.accountNumber}
                              </span></p>
                            <button onClick={() => copyCode1(acdata?.accountNumber)}>Copy</button>
                          </div>

                        </div>
                        <div class="alrt_deposit" >
                          <div className="Refer_code">
                            <p style={{ fontSize: "20px" }}>
                              Beneficiary Name :  <span style={{ color: 'red' }} className="mb-4">
                                {acdata?.accountHolderName}
                              </span></p>
                            <button onClick={() => copyCode1(acdata?.accountHolderName)}>Copy</button>
                          </div>

                        </div>
                        <div class="alrt_deposit" >
                          <div className="Refer_code">
                            <p style={{ fontSize: "20px" }}>
                              IFSC Code :  <span style={{ color: 'red' }} className="mb-4">
                                {acdata?.ifscCode}
                              </span></p>
                            <button onClick={() => copyCode1(acdata?.ifscCode)}>Copy</button>
                          </div>

                        </div>
                      </>
                      : ""
                  }

                  <div>
                    <p>
                      NOTE :- पेमेंट सक्सेस होने के बाद निचे दिय गए बटन पर क्लिक करके स्क्रीनशॉट और UTR नंबर डालके सबमिट कर दे |
                    </p>
                  </div>

                  <div className="mb-5 d-flex justify-content-center">
                    <button
                      className="results_btn results_btn_win mt-2"
                      onClick={handleShow_won}
                    >
                      {" "}
                      Upload Payment Details
                    </button>
                  </div>
                </>
              )}


            </div>
          )}

          {Boolean(process1) && (
            <div className="loaderReturn" style={{ zIndex: "99" }}>
              <img
                src={"/images/LandingPage_img/loader1.gif"}
                style={{ width: "100%" }}
              />
            </div>
          )}
        </div>
      </div>

      <section className="win_modal">
        <Modal
          show={show_won}
          onHide={handleClose_won}
          className="cancel_popup_reason_popup"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div>
              <h3>Payment Details</h3>
              <div>
                <lable className="commaon_label">AMOUNT</lable>
                <input
                  className="commaon_input_box mb-2"
                  type="number"
                  required
                  value={global}
                  onChange={(e) => setGlobal(e.target.value)}
                  placeholder="Enter amount"
                  readOnly
                />
                <lable className="commaon_label mt-4">UTR NUMBER</lable>
                <input
                  className="commaon_input_box"
                  type="text"
                  required
                  value={utr}
                  onChange={(e) => setutr(e.target.value)}
                  placeholder="Enter UTR Number"
                />
              </div>

              <div className={`${css1.doc_upload} mt-4 upload_ss_btn`}>
                <input
                  type="file"
                  onChange={handleChange}
                  accept="image/*"
                  required
                />
                {!scrnshot && (
                  <div className="cxy flex-column position-absolute ">
                    <i
                      className="fa-solid fa-arrow-up"
                      style={{ color: "#fff" }}
                    ></i>
                    <div
                      className={`${css1.sideNav_text} mt-2 upload_ss_btn_name`}
                    >
                      Upload screenshot.
                    </div>
                  </div>
                )}
                {scrnshot && (
                  <div className={css1.uploaded}>
                    <img
                      src="/images/file-icon.png"
                      width="26px"
                      alt=""
                      style={{ marginRight: "20px" }}
                    />
                    <div
                      className="d-flex flex-column"
                      style={{ width: "80%" }}
                    >
                      <div
                        className={`${css1.name} `}
                        style={{ color: "#fff" }}
                      >
                        {scrnshot.name}
                      </div>
                      <div className={css1.size}>
                        {(scrnshot.size / 1024 / 1024).toFixed(2)} MB
                      </div>
                    </div>
                    <div className="image-block">
                      <img
                        src="/images/global-cross.png"
                        width="10px"
                        alt=""
                        onClick={() => {
                          clearImage();
                          handleClose_won();
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div style={{ width: "100%", marginTop: "20px" }}>
                <img
                  src={scrnshot1}
                  style={{ width: "100%" }}
                  className="screenshot_img"
                />
              </div>

              {fecthStatus == null && fecthStatus == undefined && (
                <>
                  {isLoading1 ? (
                    <button className="Login-button cxy" disabled>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </button>
                  ) : (
                    <input
                      type="submit"
                      value="Submit"
                      className="btn btn-danger mt-3 text-white results_btn w-100"
                      id="post"
                      onClick={ManualPayments}
                      disabled={!utr}
                    />
                  )}
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </section>

      <SabpaisaPaymentGateway clientCode={clientCode} transUserName={transUserName} transUserPassword={transUserPassword} authkey={authkey} authiv={authiv} payerName={payerName} payerEmail={payerEmail} payerMobile={payerMobile} clientTxnId={clientTxnId} amount={global} payerAddress={payerAddress} callbackUrl={callbackUrl} isOpen={isOpen} />


      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
};

export default Addcase;
